import axios from '~/utils/axiosInstance';

export const uploadDealSpreadsheet = async function (id: string, dealType: string, fileName: string) {
  const response = await axios.post(`/admin/deal-spreadsheet/${id}?dealType=${dealType}`, { fileName });
  return response.data;
};

export const getDealSpreadsheetDownloadUrl = async function (id: string, dealType: string) {
  const response = await axios.get(`/admin/deal-spreadsheet/${id}?dealType=${dealType}`);
  return response.data;
};

export const updateDealSpreadsheet = async function (id: string, dealType: string, fileName: string) {
  const response = await axios.patch(`/admin/deal-spreadsheet/${id}?dealType=${dealType}`, { fileName });
  return response.data;
};

export const removeDealSpreadsheet = async function (id: string, dealType: string) {
  const response = await axios.delete(`/admin/deal-spreadsheet/${id}?dealType=${dealType}`);
  return response.data;
};